/**
 * Star 量化专区 / 模版策略 / 热门专题 相关接口
 * @see yapi.json
 */
import request from '@/utils/request'
import { apiUrl } from './config'
import { starHeaders } from './starApiCommon'

const FACTOR_BASE = apiUrl + '/rjhy-factor-selector/api/1'
const RJHY_EDU_URANUS_BASE = apiUrl + '/rjhy-edu-uranus'
const NEWS_BASE = apiUrl + '/rjhy-news/api/1'

type dataType = any

export default {
  /**
   * 查询用户权限
   * @see YApi 80423 GET /quantstar/user/permission
   */
  getUserPermission(data?: dataType): Promise<any> {
    return request({
      url: FACTOR_BASE + '/quantstar/user/permission',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 量化专区 - 热门专题、圈子、视频直播卡片列表
   * @see YApi 79943 GET /home/star/invest/tab/list
   */
  getInvestTabList(data?: dataType): Promise<any> {
    return request({
      url: RJHY_EDU_URANUS_BASE + '/api/1/home/star/invest/tab/list',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 模版策略
   * @see YApi 80427 GET /quantstar/strategy/square
   * @param pageNo 页码
   * @param pageSize 每页条数
   * @param typeID 类型：0 全部（用 typeIDList 中的 typeID），-1 精选策略
   */
  getStrategySquare(data?: dataType): Promise<any> {
    return request({
      url: FACTOR_BASE + '/quantstar/strategy/square',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 策略详情
   * @see YApi 67731 GET /quantstar/strategy/detail
   * @param taskID 策略/任务 ID（必填）
   * @param watchWord 口令兑换（可选）
   */
  getStrategyDetail(data?: dataType): Promise<any> {
    return request({
      url: FACTOR_BASE + '/quantstar/strategy/detail',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 热门专题 - 栏目 tab 查询
   * @see YApi 79903 GET /star/hot/subject/column/tab/query
   * @param brokerCode 券商编码（可选）
   */
  getHotSubjectColumnTabs(data?: dataType): Promise<any> {
    return request({
      url: RJHY_EDU_URANUS_BASE + '/api/1/star/hot/subject/column/tab/query',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 查询栏目文章列表
   * @see YApi 151370 GET /rjhy-news/api/1/{channel}/news/list
   * @param channel 渠道，默认 gw
   * @param columnCodes 栏目编码，多个用逗号隔开
   * @param hasContent 是否含正文，0 不含
   * @param dataTypes 数据类型，3 文章
   * @param showPermission 是否展示权限，0 否
   * @param appCode 应用编码，如 com.rjhy.uranus
   * @param limit 每页条数
   * @param sortTimestamp 分页游标（加载更多时传上一页最后一条的 sortTimestamp）
   */
  getColumnNewsList(data?: dataType): Promise<any> {
    const payload = data?.data || {}
    const channel = payload.channel || 'gw'
    const { channel: _, ...params } = payload

    return request({
      url: `${NEWS_BASE}/${channel}/news/list`,
      method: 'get',
      params,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 文章详情
   * GET /rjhy-news/api/1/{channel}/news/content
   */
  getNewsContent(data?: dataType): Promise<any> {
    const payload = data?.data || {}
    const channel = payload.channel || 'jfztpc'
    const { channel: _, ...params } = payload

    return request({
      url: `${NEWS_BASE}/${channel}/news/content`,
      method: 'get',
      params,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },

  /**
   * 获取文章视频地址
   * GET /rjhy-news/api/1/{channel}/video/url
   */
  getArticleVideo(data?: dataType): Promise<any> {
    const payload = data?.data || {}
    const channel = payload.channel || 'gw'
    const { channel: _, ...params } = payload

    return request({
      url: `${NEWS_BASE}/${channel}/video/url`,
      method: 'get',
      params,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true,
    })
  },
}
